export default __webpack_public_path__ + "static/media/chevron-down-circle.2c77bd5e.svg";